import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { FloatingActionButtonComponent } from './floating-action-button/floating-action-button.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  providers: [provideNgxMask()],
  declarations: [
    FloatingActionButtonComponent,
  ],
  imports: [
    CommonModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatPaginatorModule,
    MatSortModule,
    MatCheckboxModule,
    NgxMaskDirective,
    NgxMaskPipe,
    MatTooltipModule
  ],
  exports: [
    FloatingActionButtonComponent
  ],
})
export class ButtonsModule { }
